import { ReactComponent as BrandActiveIcon } from '../../../assets/device-hub/sidebar/brand-active.svg';
import { ReactComponent as BrandIcon } from '../../../assets/device-hub/sidebar/brand.svg';
import { ReactComponent as ConnectorRatingActiveIcon } from '../../../assets/device-hub/sidebar/connecter-rating-active.svg';
import { ReactComponent as ConnectorRatingIcon } from '../../../assets/device-hub/sidebar/connecter-rating.svg';
import { ReactComponent as DashboardActiveIcon } from '../../../assets/device-hub/sidebar/dashboard-device-active.svg';
import { ReactComponent as DashboardIcon } from '../../../assets/device-hub/sidebar/dashboard-device.svg';
import { ReactComponent as DeviceListActiveIcon } from '../../../assets/device-hub/sidebar/device-list-active.svg';
import { ReactComponent as DeviceListIcon } from '../../../assets/device-hub/sidebar/device-list.svg';
import { ReactComponent as FirmwareActiveIcon } from '../../../assets/device-hub/sidebar/firmware-active.svg';
import { ReactComponent as FirmwareIcon } from '../../../assets/device-hub/sidebar/firmware.svg';
import { ReactComponent as ModelActiveIcon } from '../../../assets/device-hub/sidebar/model-active.svg';
import { ReactComponent as ModelIcon } from '../../../assets/device-hub/sidebar/model.svg';
import { MenuItem } from '../../../interface/menuItem-interfaces';
import { permissionCheck } from '../../../shared-functions/JWTDocodeFunction';

/**
 * Charger Menus List
 * @returns {MenuItem[]} Array of charger menu items
 */
const ChargerMenu = (): MenuItem[] => [
  {
    id: 'Dashboard',
    label: 'dashboard',
    url: '/ev-admin/ev-device-hub/dashboard',
    svgIcon: <DashboardIcon />,
    activeSvgIcon: <DashboardActiveIcon />,
    allow: permissionCheck('devicesDashboard'),
  },
  {
    id: 'evDeviceHub',
    label: 'devices',
    url: '/ev-admin/ev-device-hub/devices',
    svgIcon: <DeviceListIcon />,
    activeSvgIcon: <DeviceListActiveIcon />,
    allow: permissionCheck('devicesEvDeviceHubView'),
  },
  {
    id: 'connector-rating',
    label: 'connectorRating',
    url: '/ev-admin/ev-device-hub/connector-rating',
    svgIcon: <ConnectorRatingIcon />,
    activeSvgIcon: <ConnectorRatingActiveIcon />,
    allow: permissionCheck('devicesRatingView'),
  },
  {
    id: 'brand',
    label: 'brands',
    url: '/ev-admin/ev-device-hub/brands',
    svgIcon: <BrandIcon />,
    activeSvgIcon: <BrandActiveIcon />,
    allow: permissionCheck('devicesBrandsView'),
  },
  {
    id: 'model',
    label: 'models',
    url: '/ev-admin/ev-device-hub/models',
    svgIcon: <ModelIcon />,
    activeSvgIcon: <ModelActiveIcon />,
    allow: permissionCheck('devicesModelsView'),
  },
  {
    id: 'firmware-version',
    label: 'firmwareLibrary',
    url: '/ev-admin/ev-device-hub/firmware-versions',
    svgIcon: <FirmwareIcon />,
    activeSvgIcon: <FirmwareActiveIcon />,
    // TEMP: reusing devicesBrandsView until firmwareArtifactsView is provisioned on the backend
    allow: permissionCheck('devicesBrandsView'),
  },
];

export default ChargerMenu;
